import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";


const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "tournament/customer-master-action", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "tournament/customer-list", {}, headerConfig);
        return response;
};


// const deleteclub = async (data) => {
//     const response = await axios
//         .post(BASE_API_URL + "club/delete", data, headerConfig);
//         return response.data;
//   };




const generalCustomerService = {
    save,
    list    
};

export default generalCustomerService;